/* eslint eqeqeq: 'off' */
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Col, Button, FormGroup } from 'reactstrap';
import ErrorGif from '../../../../../Assets/images/Error.gif';
import Currencies from '../../../../../Resources/Currencies';
import * as ErrorMessage from '../../../../../Resources/ErrorMessages';
//eslint-disable-next-line
import {PostFixedCharges, PutFixedCharges} from '../../../../../action/tenantAction';
import { closeModalPopUp } from '../../../../../action/modalStateAction';

let IsEdit = false;
class AddFixedCharges extends Component {
    componentWillMount(){
        this.setState({  
            FixedChargeDetails: this.props.parentToChildData[1]
        });
        IsEdit = this.props.parentToChildData[0];
    }
    constructor(props) {
        super(props);
        this.state = {
            TenantID: this.props.tenantID_Reducer,
            error_msg: false,
            FixedChargeDetails: []
        };
        this.Submit = this.Submit.bind(this);
        this.CloseModal = this.CloseModal.bind(this);
        this.displayError = this.displayError.bind(this);
    }


    displayError() {
        this.setState({
            error_msg: true,
        });
    }


    Submit(event) {    
                                          // Submit fixed charges data
        event.preventDefault();
        var FixedRateId = 0;
        if(IsEdit)
            FixedRateId = this.state.FixedChargeDetails[0].fixedChargeId;
        var Data = {
            "fixedChargeId": FixedRateId,
            "fixedChargeName": this.refs.fxname.value,
            "fixedRate": (this.refs.fxcharge.value == null || this.refs.fxcharge.value == "") ? 0 : parseFloat(this.refs.fxcharge.value).toFixed(2),
        };
        var tenant_Id = this.state.TenantID;
        if (Data.fixedChargeName == "" ||  Number.isNaN(Number(this.refs.fxcharge.value))) {
            this.displayError();
        }
        else {
            if (tenant_Id != undefined){
                if(!IsEdit)
                    this.props.PostFixedCharges(Data,tenant_Id);
                else
                    this.props.PutFixedCharges(Data,tenant_Id)
            }
            this.CloseModal();
        }

    }
    componentWillReceiveProps(nextProps) {
        if(this.props != nextProps) {
          this.setState({  
            TenantID: nextProps.tenantID_Reducer
            });
        }
    }
      


    CloseModal() {
        this.setState({  
            FixedChargeDetails: []
        });
        IsEdit = false;
        this.props.closeModalPopUp("close");
    }


    render(CurrencyID) {
        let Error_Message = null, FxName = null, FxRate = null, CurrencySym = '$', Header = 'Add Fixed Charge';

        (this.state.error_msg == true) ? Error_Message = <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" />  {ErrorMessage.changeLimits_error}</p> : Error_Message = " ";

        if(this.props.CurrencyID != undefined && this.props.CurrencyID != null && this.props.CurrencyID != ""){
            CurrencySym = Currencies.CurrencySymbol(this.props.CurrencyID);
        }
        if(IsEdit && this.state.FixedChargeDetails != null && this.state.FixedChargeDetails.length){
            FxName = this.state.FixedChargeDetails[0].fixedChargeName;
            FxRate = this.state.FixedChargeDetails[0].fixedRate;
            Header = 'Edit Fixed Charge';
        }
        return (
            <div className="AddFixedCharges_Modal">
                {Error_Message}
                <h4 className="Modal_form_title">{Header}</h4>
                <div className="Modal_form_group ">
                    <label className="AddFixedCharges_label">Name</label>
                    <input ref='fxname' className="AddFixedCharges_input default-input" defaultValue={FxName} />
                </div>

                <div className="Modal_form_group ">
                    <label className="AddFixedCharges_label">Charge</label>
                    <input type="text"  ref='fxcharge' defaultValue={FxRate} className="AddFixedCharges_charges_input default-input" />&nbsp;&nbsp;<span className="temp_lbl"> {CurrencySym} </span>
                </div>
                <FormGroup row  className="btns_group">
                    <Col sm={{ size: 12 }}>
                        <Button className="btn-gray btn-md ChangeLimits_Cancelbtn" onClick={this.CloseModal} > Cancel </Button>
                        <Button className="btn-success btn-md ChangeLimits_Applybtn" onClick={this.Submit} >Save</Button>
                    </Col>
                </FormGroup>
            </div>
        );
    }
}


const mapStateToProps = state => {
        return {
          tenantID_Reducer: state.ViewtenantsRootReducer.FixedCharges.tenantId,
          CurrencyID: state.ViewtenantsRootReducer.CompanyInformation.currencyId
        };
      };

const mapDispatchToProps = dispatch => {
    return {
        PostFixedCharges: (Data,TenantID) => dispatch(PostFixedCharges(Data,TenantID)),
        PutFixedCharges: (Data,TenantID) => dispatch(PostFixedCharges(Data,TenantID)),
        closeModalPopUp: (modaldata) => dispatch(closeModalPopUp(modaldata))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddFixedCharges);



